module.exports = __webpack_public_path__ + "static/img/28.be9f22f7.webp";